import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import ProtectedRoute from './components/ProtectedRoute';
import RetailAdminDashboard from './components/RetailAdminDashboard';
import NotificationTest from './pages/NotificationTest';

// import './App.css';


function AppRoutes() {
  const { user } = useAuth();

  return (
    <Routes>
      <Route 
        path="/login" 
        element={!user ? <Login /> : <Navigate to="/dashboard" replace />} 
      />
      <Route 
        path="/dashboard" 
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        } 
      />
       <Route 
        path="/RetailAdminDashboard" 
        element={
          <ProtectedRoute>
            <RetailAdminDashboard />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/NotificationTest" 
        element={
          <ProtectedRoute>
            <NotificationTest />
          </ProtectedRoute>
        } 
      />
     
      <Route 
        path="/" 
        element={<Navigate to={user ? "/dashboard" : "/login"} replace />} 
      />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <AppRoutes />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;